import { DateTime, Interval } from 'luxon';

import { TimelineConfig } from '@apps/pata/services/planning/timeline-constants';
import { AbscissaPositionEnum, ZoomLevelEnum } from '@apps/pata/services/planning/enums';
import { PeriodDatetimeBoundaries } from '@apps/pata/models/period-datetime-boundaries';

import { ProjectsExtremas } from './projects-extremas';

export class TimelineInfos
{
    /**
     * Premier jour de la période considérée
     */
    public minExtrema: DateTime;
    /**
     * Dernier jour dre la période considérée
     */
    public maxExtrema: DateTime;
    /**
     * Nombre de jours de la période
     */
    private _totalDays : number = Number.NaN;
    public get totalDays () : number
    {
        return this._totalDays;
    }
    public get cellDayRange (): number[]
    {
        return [...Array(this.totalDays + 1).keys()];
    }
    private timelineConfig: TimelineConfig;
    private _sinceTimeline: DateTime;
    get sinceTimeline (): DateTime
    {
        return this._sinceTimeline;
    }
    private _untilTimeline: DateTime;
    get untilTimeline (): DateTime
    {
        return this._untilTimeline;
    }

    constructor (projectsExtremas: ProjectsExtremas)
    {
        this.minExtrema = projectsExtremas.minExtrema;
        this.maxExtrema = projectsExtremas.maxExtrema;
    }

    public buildLevel1Period (timelineConfig: TimelineConfig, zoomLevel: ZoomLevelEnum): void
    {
        this.timelineConfig = timelineConfig;
        this._sinceTimeline = this.minExtrema.startOf(this.timelineConfig.level1.dtUnit).startOf('day');
        this._untilTimeline = this.maxExtrema.endOf(this.timelineConfig.level1.dtUnit).startOf('day');
        this._totalDays = Interval.fromDateTimes(this._sinceTimeline, this._untilTimeline.plus({ day: 1 })).length('days');
    }

    /**
     *
     * @returns la taille en pixels de la période considérée
     */
    public getFullWidth = (zoomLevelEnum: ZoomLevelEnum): number =>
        this.timelineConfig.dayCellSize * this._totalDays * (zoomLevelEnum === ZoomLevelEnum.DayHalfday ? 2 : 1);

    // /**
    //  * @param {number} x Abscisse en pixel d'un point (cliqué)
    //  * @returns {DateTime} Date correspondant au point
    //  */
    // public getDateFromAbscissa = (x: number): DateTime =>
    //     DateTime.fromJSDate(this.timelineScale.invert(x));

    /**
     * @param {DateTime} dt Date dont on veut connaître la position physique
     * @returns {number} Valeur en pixel de la position de cette date par rapport à la timeline complète
     */
    public getAbscissaFromDate = (zoomLevelEnum: ZoomLevelEnum, dt: DateTime, ap: AbscissaPositionEnum = AbscissaPositionEnum.Middle): number =>
    {

        if (zoomLevelEnum !== ZoomLevelEnum.DayHalfday)
        {
            const nbDays: number = new PeriodDatetimeBoundaries(this._sinceTimeline, dt, false).nbDays;
            switch (ap)
            {
                case AbscissaPositionEnum.Start:
                    return this.timelineConfig.dayCellSize * nbDays;

                case AbscissaPositionEnum.Middle:
                    return this.timelineConfig.dayCellSize * (0.5 + nbDays);

                case AbscissaPositionEnum.End:
                    return this.timelineConfig.dayCellSize * (1 + nbDays);
            }
        }
        else
        {
            const nbDays: number = new PeriodDatetimeBoundaries(this._sinceTimeline, dt, false).nbDays;

            switch (ap)
            {
                case AbscissaPositionEnum.Start:
                    return this.timelineConfig.dayCellSize * nbDays;

                case AbscissaPositionEnum.Middle:
                    return this.timelineConfig.dayCellSize * (0.5 + nbDays);

                case AbscissaPositionEnum.End:
                    return this.timelineConfig.dayCellSize * (1 + nbDays);
            }
        }
    };
}
